export const CLUSTER_GRID_SIZE       = 60;   // pixel length of one cell
export const CLUSTER_MIN_SIZE        = 10;    // markers required to merge
export const CLUSTER_MAX_ZOOM        = 17;   // dissolve at street level
export const CLUSTER_TEXT_COLOR = '#ffffff';

// utils/clusterFlatSvg.js   — overwrite the previous one
export function getClusterSvg({
    fill        = '#0e87cc', // Sysco blue
    discOpacity = 0.65,
    ring        = true,
    ringWidth   = 4,         // px
    ringOpacity = 0.25       // 25 % visible
  } = {}) {
    const r      = 22;                         // overall radius for 44×44 svg
    const svg =
  `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 ${r * 2} ${r * 2}">
         <circle cx="${r}" cy="${r}" r="${r - ringWidth}"
                 fill="${fill}" fill-opacity="${discOpacity}"/>                         <!-- solid disc -->
         ${ring
           ? `<circle cx="${r}" cy="${r}" r="${r - ringWidth / 2}"
                      fill="none"
                      stroke="${fill}"
                      stroke-opacity="${ringOpacity}"
                      stroke-width="${ringWidth}" />`
           : ''}
       </svg>`;
   
    const base64 =
      typeof window !== 'undefined'
        ? window.btoa(svg)
        : Buffer.from(svg).toString('base64');
   
    return `data:image/svg+xml;base64,${base64}`;
  }

export const blueSvg = getClusterSvg();
 
export const clusterStyles = [
  { url: blueSvg, width: 40, height: 40, textColor: CLUSTER_TEXT_COLOR, textSize:13 }, // 2-9
  { url: blueSvg, width: 56, height: 56, textColor: CLUSTER_TEXT_COLOR, textSize:14 }, // 10-99
  { url: blueSvg, width: 72, height: 72, textColor: CLUSTER_TEXT_COLOR, textSize:15 }, // 100-999
  // add a 4th / 5th object if you expect >1 000 markers in one cluster
];

// original natural size
const naturalW = 35;
const naturalH = 45;
 
// choose a scale (0.8 = 80 %)
const SCALE   = 0.7;
const drawW   = naturalW * SCALE;   // 28
const drawH   = naturalH * SCALE;   // 36

export function iconSpec(url) {
    return {
      url,                                           // image src
      size:        new google.maps.Size(drawW, drawH),       // natural bitmap size
      scaledSize:  new google.maps.Size(drawW, drawH),       // draw 1 : 1 on screen
      anchor:      new google.maps.Point(drawW / 2, drawH)   // tip of the pin
    };
  }